import { render, staticRenderFns } from "./Gaps.vue?vue&type=template&id=6dbe955c&"
import script from "./Gaps.vue?vue&type=script&lang=ts&"
export * from "./Gaps.vue?vue&type=script&lang=ts&"
import style0 from "./Gaps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports